<template>
  <v-form autocomplete="off">
    <v-row class="requests-filters">
      <v-col v-show="!expanded">
        <v-row>
          <v-col
            v-if="!filtersFilled"
            cols="12"
            sm="6"
            lg="6"
            class="pb-0"
          >
            <v-text-field
              v-model.trim="filters.ean"
              v-mask="'##################'"
              label="Hledání dle EANu"
              outlined
              dense
              background-color="white"
              append-icon="mdi-magnify"
              @click:append="filter"
              :prepend-icon="filters.ean ? 'mdi-close' : 'mdi-none'"
              @click:prepend.prevent="removeFromFilter('ean')"
              @keyup.enter="filter()"
              data-cy="eanFastFilter"
            />
          </v-col>

          <v-col
            v-if="filters.ean && filtersFilled"
            cols="auto"
          >
            <v-row
              no-gutters
              align="center"
              class="flex-nowrap"
            >
              <v-col
                cols="auto"
                class="mr-1"
              >
                <v-btn
                  depressed
                  icon
                  @click="removeFromFilter('ean')"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>

              <v-col cols="auto">
                Hledání dle EANu: <b>{{ filters.ean }}</b>
              </v-col>
            </v-row>
          </v-col>

          <v-col
            v-if="filters.ids"
            cols="auto"
          >
            <v-row
              no-gutters
              align="center"
              class="flex-nowrap"
            >
              <v-col
                cols="auto"
                class="mr-1"
              >
                <v-btn
                  depressed
                  icon
                  @click="removeFromFilter('ids')"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>

              <v-col cols="auto">
                Hledání dle čísla požadavku: <b>{{ filters.ids }}</b>
              </v-col>
            </v-row>
          </v-col>

          <v-col
            v-if="filters.dateSince"
            cols="auto"
          >
            <v-row
              no-gutters
              align="center"
              class="flex-nowrap"
            >
              <v-col
                cols="auto"
                class="mr-1"
              >
                <v-btn
                  depressed
                  icon
                  @click="removeFromFilter('dateSince')"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>

              <v-col cols="auto">
                Datum od:
                <b>
                  {{ dateFromFormatted }}
                </b>
              </v-col>
            </v-row>
          </v-col>

          <v-col
            v-if="filters.dateUntil"
            cols="auto"
          >
            <v-row
              no-gutters
              align="center"
              class="flex-nowrap"
            >
              <v-col
                cols="auto"
                class="mr-1"
              >
                <v-btn
                  depressed
                  icon
                  @click="removeFromFilter('dateUntil')"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>

              <v-col cols="auto">
                Datum do:
                <b>
                  {{ dateToFormatted }}
                </b>
              </v-col>
            </v-row>
          </v-col>

          <v-col
            v-if="filters.statuses && filters.statuses.length"
            cols="auto"
          >
            <v-row
              no-gutters
              align="center"
              class="flex-nowrap"
            >
              <v-col
                cols="auto"
                class="mr-1"
              >
                <v-btn
                  depressed
                  icon
                  @click="removeFromFilter('statuses')"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>

              <v-col cols="auto">
                Status:
                <b>
                  {{ filterStatuses }}
                </b>
              </v-col>
            </v-row>
          </v-col>

          <v-col
            v-if="filters.types && filters.types.length"
            cols="auto"
          >
            <v-row
              no-gutters
              align="center"
              class="flex-nowrap"
            >
              <v-col
                cols="auto"
                class="mr-1"
              >
                <v-btn
                  depressed
                  icon
                  @click="removeFromFilter('types')"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>

              <v-col cols="auto">
                Název požadavku:
                <b>
                  {{ filterTypes }}
                </b>
              </v-col>
            </v-row>
          </v-col>

          <v-col v-if="dealersFilter && filters.dealerIds && filters.dealerIds.length" cols="auto">
            <v-row no-gutters align="center" class="flex-nowrap">
              <v-col cols="auto" class="mr-1">
                <v-btn icon @click="removeFromFilter('dealerIds')">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>

              <v-col cols="auto">
                Hledání dle zadavatele: <b>{{ filterUsers('dealerIds') }}</b>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>

      <v-col v-show="expanded">
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="6"
            class="pb-0"
          >
            <v-text-field
              v-model.trim="filters.ean"
              v-mask="'##################'"
              label="Hledání dle EANu"
              outlined
              dense
              background-color="white"
              :prepend-icon="filters.ean ? 'mdi-close' : 'mdi-none'"
              @click:prepend.prevent="filters.ean = null"
              data-cy="eanFilter"
            />
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pb-0"
          >
            <v-text-field
              v-model="filters.ids"
              v-mask="'######'"
              label="Hledání dle čísla požadavku"
              outlined
              dense
              background-color="white"
              :prepend-icon="filters.ids ? 'mdi-close' : 'mdi-none'"
              @click:prepend="filters.ids = null"
              min="1"
              step="1"
              data-cy="numberFilter"
            />
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pb-0"
          >
            <v-autocomplete
              class="multi-sika"
              v-model.trim="filters.statuses"
              label="Status požadavku"
              outlined
              dense
              background-color="white"
              :prepend-icon="filters.statuses && filters.statuses.length ? 'mdi-close' : 'mdi-none'"
              @click:prepend="filters.statuses = null"
              :items="statuses"
              item-text="localizedText"
              item-value="name"
              :disabled="statusesLoading"
              :loading="statusesLoading"
              data-cy="statusFilter"
              multiple
            >
              <template v-slot:selection="{ index, item }">
                <span
                  v-if="index === 0"
                  class="caption mr-2"
                >
                  <template v-if="filters.statuses.length === 1">
                    {{ item.localizedText }}
                  </template>
                  <template v-else-if="
                    filters.statuses.length > 1 &&
                    filters.statuses.length < 5">
                    Vybrány {{ filters.statuses.length }} položky
                  </template>
                  <template v-else-if="filters.statuses.length > 4">
                    Vybráno {{ filters.statuses.length }} položek
                  </template>
                </span>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pb-0 filter-datepicker filter-datepicker--from"
          >
            <v-text-field
              outlined
              dense
              background-color="white"
              v-model.trim="dateFromFormatted"
              label="Datum od"
              append-icon="mdi-calendar-arrow-left"
              @blur="setParsedDateSince(dateFromFormatted)"
              :prepend-icon="dateFromFormatted ? 'mdi-close' : 'mdi-none'"
              @click:prepend="filters.dateSince = null"
              @click:append="menuForDateFrom = true"
              data-cy="dateFromFilter"
            />

            <v-menu
              attach=".filter-datepicker--from"
              ref="menuForDateFrom"
              v-model="menuForDateFrom"
              :close-on-content-click="false"
              transition="scale-transition"
              max-width="290px"
              min-width="290px"
            >
              <v-date-picker
                :first-day-of-week="1"
                :max="maxForDateFrom"
                v-model="filters.dateSince"
                no-title
                color="rgba(0, 0, 0, 0.87)"
                @input="menuForDateFrom = false"
              />
            </v-menu>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pb-0 filter-datepicker filter-datepicker--to"
          >
            <v-text-field
              outlined
              dense
              background-color="white"
              v-model.trim="dateToFormatted"
              label="Datum do"
              append-icon="mdi-calendar-arrow-right"
              @blur="setParsedDateUntil(dateToFormatted)"
              :prepend-icon="dateToFormatted ? 'mdi-close' : 'mdi-none'"
              @click:prepend="filters.dateUntil = null"
              @click:append="menuForDateTo = true"
              data-cy="dateToFilter"
            />
            <v-menu
              attach=".filter-datepicker--to"
              ref="menuForDateTo"
              v-model="menuForDateTo"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <v-date-picker
                :first-day-of-week="1"
                :max="maxForDateTo"
                :min="minForDateTo"
                v-model="filters.dateUntil"
                no-title
                color="rgba(0, 0, 0, 0.87)"
                @input="menuForDateTo = false"
              />
            </v-menu>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="6"
            class="pb-0"
          >
            <v-autocomplete
              class="multi-sika"
              v-model.trim="filters.types"
              label="Název požadavku"
              outlined
              dense
              background-color="white"
              :prepend-icon="filters.types && filters.types.length ? 'mdi-close' : 'mdi-none'"
              @click:prepend="filters.types = null"
              :items="types"
              item-text="localizedText"
              item-value="name"
              :disabled="typesLoading"
              :loading="typesLoading"
              data-cy="typeFilter"
              chips
              small-chips
              multiple
            >
              <template v-slot:selection="{ index, item }">
                <span
                  v-if="index === 0"
                  class="caption mr-2"
                >
                  <template v-if="filters.types.length === 1">
                    {{ item.localizedText }}
                  </template>
                  <template v-else-if="
                    filters.types.length > 1 &&
                    filters.types.length < 5">
                    Vybrány {{ filters.types.length }} položky
                  </template>
                  <template v-else-if="filters.types.length > 4">
                    Vybráno {{ filters.types.length }} položek
                  </template>
                </span>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="6"
            class="pb-0"
            v-if="dealersFilter"
          >
            <SolverAutocomplete
              class="multi-sika"
              :dealers="true"
              v-model.trim="filters.dealerIds"
              :items="dealers"
              return-object
              label="Hledání dle zadavatele"
              outlined
              dense
              background-color="white"
              :prepend-icon="
                filters.dealerIds && filters.dealerIds.length ?
                'mdi-close' :
                'mdi-none'"
              @click:prepend="filters.dealerIds = null"
              multiple
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col
        cols="auto"
        class="pb-0"
      >
        <v-btn
          depressed
          text
          @click="expanded = !expanded"
        >
          {{ expanded ? '' : 'Pokročilý filtr' }}
          <v-icon
            right
            dark
          >
            {{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          </v-icon>
        </v-btn>
      </v-col>

      <v-col
        v-show="expanded"
        cols="12"
        class="pt-0 text-right"
      >
        <v-btn
          depressed
          @click="resetFilter"
          height="40px"
          min-width="130px"
          color="primary"
          outlined
        >
          Zrušit filtr
        </v-btn>

        <v-btn
          depressed
          @click="filter"
          height="40px"
          min-width="130px"
          color="primary"
          class="ml-4"
        >
          Filtrovat
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex';
import formatDate from '@/utils/formatDate';
import SolverAutocomplete from '@/components/forms/inputs/SolverAutocomplete.vue';
import parseDate from '@/utils/parseDate';

export default {
  name: 'RequestsFilters',
  components: {
    SolverAutocomplete,
  },
  props: {
    dealersFilter: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      statusesLoading: false,
      typesLoading: false,
      expanded: false,
      dateFromFormatted: null,
      dateToFormatted: null,
      menuForDateFrom: false,
      menuForDateTo: false,
      statuses: [],
      dealers: [],
      types: [],
      filters: {
        ean: null,
        ids: null,
        dateSince: null,
        dateUntil: null,
        statuses: null,
        dealerIds: null,
        types: null,
      },
    };
  },
  watch: {
    'filters.dateSince': {
      handler() {
        this.dateFromFormatted = formatDate(this.filters.dateSince);
      },
    },
    'filters.dateUntil': {
      handler() {
        this.dateToFormatted = formatDate(this.filters.dateUntil);
      },
    },
  },
  computed: {
    filtersFilled() {
      let state = false;
      Object.keys(this.filters).forEach((filter) => {
        if (filter !== 'ean') {
          if (this.filters[filter] && this.filters[filter].length) {
            state = true;
            return true;
          }
        }
        return state;
      });
      return state;
    },
    maxForDateFrom() {
      if (this.filters.dateUntil) {
        return new Date(this.filters.dateUntil).toISOString();
      }
      return new Date().toISOString();
    },
    maxForDateTo() {
      return new Date().toISOString();
    },
    minForDateTo() {
      if (this.filters.dateSince) {
        return new Date(this.filters.dateSince).toISOString();
      }
      return null;
    },
    filterStatuses() {
      return this.getFilterData('statuses', 'statuses', 'name', 'localizedText');
    },
    filterTypes() {
      return this.getFilterData('types', 'types', 'name', 'localizedText');
    },
  },
  methods: {
    ...mapActions({
      getStatuses: 'requests/getStatuses',
      getTypes: 'requests/getTypes',
      getDealer: 'users/getDealer',
    }),
    removeFromFilter(removingFilter) {
      this.filters[removingFilter] = null;
      this.filter();
    },
    resetFilter() {
      Object.keys(this.filters).forEach((filter) => {
        this.filters[filter] = null;
      });
      this.$emit('filter', this.filters);
    },
    filterUsers(array) {
      let filterData = '';
      if (Array.isArray(this.filters[array])) {
        this.filters[array].forEach((value) => {
          if (value && value.name) {
            if (filterData.length) {
              filterData += ', ';
            }
            filterData += value.name;
          }
          if (value && value.fullName) {
            if (filterData.length) {
              filterData += ', ';
            }
            filterData += value.fullName;
          }
        });
        return filterData;
      }
      if (this.filters[array].name) {
        return this.filters[array].name;
      }
      if (this.filters[array].fullName) {
        return this.filters[array].fullName;
      }
      return filterData;
    },
    filter() {
      this.expanded = false;
      this.$emit('filter', this.filters);
    },
    getDataByFilteredValue(key, filterValue, searchKey) {
      const data = this[key].find(
        (value) => value[searchKey] === filterValue,
      );
      return data;
    },
    getFilterData(key, filterKey, searchKey, keyToDisplay) {
      let filterData = '';
      if (this.filters[filterKey]) {
        if (Array.isArray(this.filters[filterKey])) {
          Object.values(this.filters[filterKey]).forEach((value) => {
            const data = this.getDataByFilteredValue(key, value, searchKey);
            if (data) {
              if (filterData.length) {
                filterData += ', ';
              }
              filterData += data[keyToDisplay];
            }
          });
          return filterData;
        }
        // filterData = this.getDataByFilterValue(key, this.filters[filterKey], searchKey);
        if (filterData) {
          return filterData[keyToDisplay];
        }
      }
      return filterData;
    },
    setParsedDateUntil(dateFormatted) {
      this.filters.dateUntil = parseDate(dateFormatted);
    },
    setParsedDateSince(dateFormatted) {
      this.filters.dateSince = parseDate(dateFormatted);
    },
    setFilter() {
      if (Object.values(this.$route.query)) {
        Object.entries(this.$route.query).forEach((keyValue) => {
          const [key, value] = keyValue;
          const multipleFilterKeys = ['statuses', 'organizationIds', 'types', 'dealerIds'];
          if (multipleFilterKeys.includes(key) && value.length) {
            const filterDataArray = value.split(',');
            if (key === 'dealerIds') {
              const dealers = [];
              filterDataArray.forEach((filterDataValue) => {
                this.getDealer(filterDataValue).then((response) => {
                  dealers.push(response.data);
                });
              });
              this.dealers = dealers;
              this.filters[key] = dealers;
            } else {
              this.filters[key] = filterDataArray;
            }
          } else if (key !== 'ean') {
            this.filters[key] = Number(value) || value;
          } else {
            this.filters[key] = value;
          }
        });
      }
    },
  },
  created() {
    this.statusesLoading = true;
    this.typesLoading = true;
    Promise.all([
      this.getStatuses().then((response) => {
        this.statuses = response.data;
      }).finally(() => {
        this.statusesLoading = false;
      }),
      this.getTypes().then((response) => {
        this.types = response.data;
      }).finally(() => {
        this.typesLoading = false;
      }),
    ]).then(() => {
      this.setFilter();
    });
  },
};
</script>

<style lang="scss">
.requests-filters {
  background: #e7e9ef;
}

.v-card__text {
  .requests-filters {
    margin-left: -16px;
    margin-right: -16px;
  }
}

.multi-sika {
  .v-select__selections {
    flex-wrap: nowrap;

    .caption {
      white-space: nowrap;
      overflow: hidden;
    }
  }
}
</style>
